import apiClient from '@u/apiClient'
import GetPackListForIndexController from '@/wayfinder/actions/App/Http/Controllers/Pack/GetPackListForIndexController'
import GetPackByIdController from '@/wayfinder/actions/App/Http/Controllers/Pack/GetPackByIdController'
import GetPackActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Pack/GetPackActivitiesByIdController'
import CreatePackController from '@/wayfinder/actions/App/Http/Controllers/Pack/CreatePackController'
import UpdatePackController from '@/wayfinder/actions/App/Http/Controllers/Pack/UpdatePackController'
import DuplicatePackController from '@/wayfinder/actions/App/Http/Controllers/Pack/DuplicatePackController'
import ReorderPacksController from '@/wayfinder/actions/App/Http/Controllers/Pack/ReorderPacksController'
import DeletePackController from '@/wayfinder/actions/App/Http/Controllers/Pack/DeletePackController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
// import router from '@/router'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchPackIndex({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetPackListForIndexController.get())
      .then(async (response) => {
        await commit('setPackList', response.data.packs)
        await commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchPackIndex', reason)
      })
  },
  async fetchPackByID({ commit }, id) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetPackByIdController.get({ pack: id }))
      .then(async (response) => {
        commit('setPack', response.data.pack)
        commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchPackByID', reason)
      })
  },
  async fetchNewPack({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'pack' } }))
      .then(async (response) => {
        await commit('setPack', response.data.pack)
        await commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewPack', reason)
      })
  },
  fetchPackActivitiesByPackID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetPackActivitiesByIdController.get({ pack: payload.pack_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  async storeNewPack({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(CreatePackController.post(), payload.pack)
      .then(async (response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('storeNewPack', reason)
      })
  },
  // endregion

  // region update
  async updatePack({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(UpdatePackController.put({ pack: payload.id }), payload.pack)
      .then((response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('updatePack', reason)
      })
  },
  async duplicatePack({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(DuplicatePackController.put({ pack: payload.id }))
      .then(async (response) => {
        if (response.status === 201) {
          await commit('setPackList', response.data.packs)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('duplicatePack', reason)
      })
  },
  async reorderPacks({ commit }, payload) {
    await apiClient
      .route(ReorderPacksController.put(), { packs: payload.packs })
      .then(async (response) => {
        if (response.status === 200) {
          commit('setPackList', response.data.packs)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('reorderPacks', reason)
      })
  },
  // endregion

  // region delete
  async deletePackById({ commit }, payload) {
    await apiClient
      .route(DeletePackController.delete.delete({ pack: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setPackList', response.data.packs)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deletePackById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeletePackById({ commit }, payload) {
    await apiClient
      .route(DeletePackController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setPackList', response.data.packs)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeletePackById', reason)
      })
  },
  // endregion

  //region order pack items
  async reorderInvoiceItems({ commit }, payload) {
    apiClient
      .put(`/api/pack/reorder-items/${payload.pack_id}`, {
        items: payload.ordered_list
      })
      .then(async (response) => {
        if (response.status === 200) {
          commit('setPack', response.data.pack)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  }
  //endregion
}
